import { useSelector } from "react-redux"
import { selectUserConfig } from "../../../state/GeneralSlice"
import ComboBox from "./ComboBox"

const retrievals = [...Array(5).keys()].map(v => v + 1);

export default function RetrievalComboBox() {
    const retrieval = useSelector((state) => selectUserConfig(state).retrieval_top_k);
    return <ComboBox label='Retrieval' name='retrieval' items={retrievals} initialValue={retrieval} />
}